export default __webpack_public_path__ + "static/media/visa_credit_card_image.c491f370.svg";